import { Platform } from "react-native";

// The ONE place that decides where a freshly-authenticated user lands.
// Consumed by useLoginRegister (normal login/signup) and the auth-handoff
// receiver (web2app sign-in). Any new authenticated entry point must route
// through this instead of hand-rolling its own branch logic.
export type PostAuthDestination = {
  target: string;
  // The caller must start the "signup" onboarding journey before navigating.
  // Kept independent of `target` on purpose: the original login flow sets the
  // journey for signup-like flows even when the immediate target is the
  // email-verification screen.
  startSignupJourney: boolean;
};

export function postAuthDestination(args: {
  onboardingStep: string | undefined;
  // Flows that should walk the user through onboarding when it isn't
  // completed: a fresh signup, or a migration/handoff account entering the
  // app for the first time.
  signupLike: boolean;
  pendingEmailVerificationToken?: string | null;
  platform?: string;
}): PostAuthDestination {
  const {
    onboardingStep,
    signupLike,
    pendingEmailVerificationToken = null,
    platform = Platform.OS,
  } = args;

  const startSignupJourney = platform !== "web" && signupLike;

  if (platform !== "web") {
    if (pendingEmailVerificationToken) {
      return {
        target: `/auth/verify-email?token=${encodeURIComponent(
          pendingEmailVerificationToken,
        )}`,
        startSignupJourney,
      };
    }
    if (onboardingStep === "email_verification_pending") {
      return { target: "/auth/verify-email", startSignupJourney };
    }
    if (signupLike) {
      return { target: "/onboarding", startSignupJourney };
    }
  }

  return { target: "/", startSignupJourney };
}
